import { toBase64 } from "./toBase64"

const isBase64 = (str)=>{
    const base64regex = /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/
    return base64regex.test(str)
}

export const updateImage = async (image, setIcon)=>{
    if(isBase64(image)) return // caso venha base64, o ícone já está setado
    if(!image) return // caso cancele selecao de imagem=
    return setIcon(await toBase64(image))
}